import menuTypes from 'common/constants/menuTypes';
import { commonTranslations, coreTranslations } from 'translations';
import featureService from '@services/feature.service';

const alertsMenuItems = _rootMenu;

function _rootMenu() {
    return {
        i18n: commonTranslations.ng_common_alerts,
        linkTitle: 'Alerts',
        icon: 'onsolve-alerts-icon',
        routeTo: '/alerts',
        isRenderable: true,
        children: _subMenu(),
        menuType: menuTypes.secondary,
        newNav: true,
        accessConfiguration: permissions => permissions.canViewAlerts()
    };
}

function _subMenu() {
    return [
        {
            i18n: coreTranslations.ng_core_inbox,
            linkTitle: 'Inbox',
            routeTo: '/inbox',
            isEnabled: true,
            isRenderable: true,
            accessConfiguration: permissions =>
                permissions.canViewAlertInbox() && featureService.getFeature('alertInbox'),
            newNav: true
        },
        {
            i18n: coreTranslations.ng_core_linkedAlerts,
            linkTitle: 'Linked Alerts',
            routeTo: '/linked-alerts',
            isEnabled: true,
            isRenderable: true,
            accessConfiguration: permissions =>
                featureService.getFeature('bulkAlertPage') && permissions.canViewBulkAlerts(),
            newNav: true
        },
        {
            i18n: coreTranslations.ng_core_desktopAlerts,
            linkTitle: 'Desktop Alerts',
            routeTo: '/desktop-alerts',
            isEnabled: true,
            isRenderable: true,
            newNav: true,
            featureName: 'desktopAlerts'
        },
        {
            i18n: coreTranslations.ng_core_ipaws,
            linkTitle: 'IPAWS',
            routeTo: '/ipaws',
            isEnabled: true,
            isRenderable: true,
            newNav: true,
            accessConfiguration: permissions => permissions.canManageIpaws() && permissions.canInitiateIpaws()
        },
        {
            i18n: coreTranslations.ng_core_scenarioLibrary,
            linkTitle: 'Scenario Library',
            routeTo: '/scenario-library',
            isEnabled: true,
            isRenderable: true,
            newNav: true,
            accessConfiguration: permissions =>
                permissions.canViewScenarioLibrary() && featureService.getFeature('scenarioLibrary')
        }
    ];
}

export default alertsMenuItems;
